import { ActivityStreamItemEventType } from '../models/activity-stream-event-type.enum';

export const ACTIVITY_STREAM_TITLE_UI_MAPPING = {
  [ActivityStreamItemEventType.SpecialPaymentApproval]: 'activity-stream.information-changed',
  [ActivityStreamItemEventType.PositionRequest]: 'activity-stream.information-changed',
  [ActivityStreamItemEventType.EvaluationMemberMassUpdate]: 'activity-stream.information-changed',
  [ActivityStreamItemEventType.EmployeeAssignmentsUpdated]: 'activity-stream.employee-assignments-updated',
  [ActivityStreamItemEventType.ReassignmentComparisonExecuted]: 'season-mgmt.monitoring.reassignments.activity-stream.reassignment-comparison-executed'
};
